import React, { useState,useEffect } from 'react';
import ReactDOM from 'react-dom';
import Sidebar from '../Sidebar/Sidebar';
import $, { data } from 'jquery';
import { useNavigate } from 'react-router-dom';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import '../pages.css';

const FetchLeads = () => {
    const [selectedBuilderType, setSelectedBuilderType] = useState('');
    const [totalLeads, setTotalLeads] = useState(0);

    const baseURL = process.env.REACT_APP_BASE_URL;
    const navigate = useNavigate();
    const [builderTypes, setBuilderTypes] = useState([]);

  const [adName, setAdName] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        $('#loading').show();
        const accessToken = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
  
        if (!accessToken) {
          navigate('/');
          console.error('Access token not found in localStorage');
          $('#loading').hide();
          return;
        }
  
        const response = await fetch(`${baseURL}/get_ads/`, {
          headers: {
            Authorization: `Token ${accessToken}`,
            'Cache-Control': 'no-cache', // Include access token in the headers
          },
        });
  
        if (!response.ok) {
          $('#loading').hide();
        }
  
        const data = await response.json();
        if (data && data.data) {
            setBuilderTypes(data.data);
          $('#loading').hide();
        }
      } catch (error) {
        console.error('Error fetching builder types:', error);
        setErrors({ selectedBuilderType: 'Error fetching builder types' });
        $('#loading').hide();
      }
    };
    
  
    fetchData();
  }, []);

  const handleBuilderTypeChange = (event) => {
    setSelectedBuilderType(event.target.value);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!selectedBuilderType) newErrors.selectedBuilderType = 'Please select an ad';
    if (!fromDate) newErrors.fromDate = 'Please select a start date';
    if (!toDate) newErrors.toDate = 'Please select an end date';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      let apiUrl = '';
      apiUrl = `${baseURL}/manual_lead_fetch/`; 
    //   if (selectedBuilderType === 'all_ads') {
    //     apiUrl = `${baseURL}/v1/fetch_leads/`; // Replace with your actual URL for all_ads
    //   } else {
    //     apiUrl = `${baseURL}/get_ads/`; // Replace with your actual URL for other cases
    //   }

      const formData = {
        selectedBuilderType,
        fromDate,
        toDate
      };

      try {
        $('#loading').show();
        const accessToken = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
      
          if (!accessToken) {
            navigate('/');
            console.error('Access token not found in localStorage');
            $('#loading').hide();
            return;
          }
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${accessToken}`,
            'Cache-Control': 'no-cache', // Include access token in the headers
          },
          body: JSON.stringify(formData)
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
          $('#loading').hide();
          toastr.error('Something went wrong');
        }

        const data = await response.json();
        console.log('API Response:', data);
        setTotalLeads(data.total_leads)
        $('#loading').hide();
        toastr.success(data.message);
      } catch (error) {
        console.error('Error:', error);
        alert('Failed to generate report. Please try again later.');
        $('#loading').hide();
      }
    }
  };


  return (
    <div className="container-fluid tms-page">
      <div className="row flex-nowrap">
        <div className="col-auto p-0"><Sidebar /></div>
        <main className="tms-main">
          <div className="tms-page-header">
            <div>
              <h2 className="tms-page-title">Fetch Leads</h2>
              <div className="tms-page-subtitle">Manually fetch leads from a date range</div>
            </div>
          </div>

          <div id="loading">
            <div className="loader">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <div className="loader-text">Loading...</div>
            </div>
          </div>

          <div className="tms-card" style={{ maxWidth: 600 }}>
            {totalLeads > 0 && <div style={{color:'#a5b4fc', fontSize:13, marginBottom:12}}>Total Leads Fetched: <strong>{totalLeads}</strong></div>}
            <form onSubmit={handleSubmit}>
              <div className="tms-form-group">
                <label className="tms-label">Select Ad Name <span>*</span></label>
                <select
                  name="ad_name"
                  id="ad_name"
                  className="tms-select"
                  required
                  value={selectedBuilderType}
                  onChange={handleBuilderTypeChange}
                >
                  <option value="">Select Ad</option>
                  <option value="all_ads">All Ads</option>
                  {builderTypes.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.builder_name}
                    </option>
                  ))}
                </select>
                {errors.selectedBuilderType && <div className="tms-error">{errors.selectedBuilderType}</div>}
              </div>

              <div className="tms-form-group">
                <label className="tms-label">From Date <span>*</span></label>
                <input
                  type="date"
                  id="fromDate"
                  className="tms-input"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
                {errors.fromDate && <div className="tms-error">{errors.fromDate}</div>}
              </div>

              <div className="tms-form-group">
                <label className="tms-label">To Date <span>*</span></label>
                <input
                  type="date"
                  id="toDate"
                  className="tms-input"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
                {errors.toDate && <div className="tms-error">{errors.toDate}</div>}
              </div>

              <button type="submit" className="tms-btn-primary" style={{ width: '100%' }}>Fetch Leads</button>
            </form>
          </div>
        </main>
      </div>
    </div>
  );
};

export default FetchLeads;
